import React, { forwardRef } from "react"

import * as s from "./Header.module.scss"

export const Burger = React.forwardRef(({ onClick, isChristmas, active }, ref) => {
  return (
    <button 
      ref={ref}
      className={`${s.Burger} ${isChristmas && s.Burger___christmas}`}
      onClick={onClick}
      aria-label="Menu toggle" 
      aria-controls="main-menu-panel" 
      aria-expanded={!active ? 'false' : 'true'}
    >
      <span className={`${s.Burger__inner} ${active && s.Burger___active} `}>
        <span className={`${s.Burger__innerLine}`}></span>
        <span className={`${s.Burger__innerLine}`}></span>
        <span className={`${s.Burger__innerLine}`}></span>
      </span>
    </button>
  )
})
